import { Box } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import TextArea from 'modules/core/components/Inputs/TextArea'
import i18n from 'modules/core/lib/i18n'

import TooltipIcon from './TooltipIcon'

interface Props {
  notesField: Field
  mixedValues?: boolean
  newVersion?: boolean
}

const ShiftNotesField = ({ notesField, mixedValues, newVersion = false }: Props) => {
  const placeholder = mixedValues
    ? i18n.t('shift_management.edit_shifts.placeholder')
    : i18n.t('shift_management.add_shift.notes_placeholder')

  return (
    <Box gap="s16" flexDirection="row">
      {newVersion && (
        <Box alignItems="center" paddingY="s8">
          <TooltipIcon.Medium
            icon="comment"
            label={i18n.t('shift_management.actions_sidepanel.tooltip.notes')}
            color="grey700"
          />
        </Box>
      )}
      <TextArea
        label={newVersion ? undefined : i18n.t('shift_management.add_shift.notes')}
        field={notesField}
        placeholder={placeholder}
      />
    </Box>
  )
}

export default observer(ShiftNotesField)
